import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import Utility from "../../../Utility";
import {Button} from "@mui/material";
import Settings from "../../../settings.json";
import {routes} from "../../../App";
import Cookies from "js-cookie";

const projectIds = Settings?.conventionProjects ? Object.keys(Settings.conventionProjects) : [];


const ConventionLinks = observer(() => {
    const {generalStore} = useStores();


    function getProcedureDeepLink(procedureId) {
        const serverAddressArr = Settings.frontlineArServer.split("://");
        const host = Settings.conventionWorkspace + "." + serverAddressArr[1]
        const serverAddress = serverAddressArr[0] + "://" + host;

        let deepPath = Utility.buildUrl(routes.DEEP_LINK_VIEWER, {
            db: Settings.conventionWorkspace,
            procedureId: procedureId + '?'
        });
        deepPath += '&t=' + Cookies.get(Settings.tokenCookieName);
        return `procedureio://frontline-ar?d=${serverAddress}${encodeURIComponent(deepPath)}`;
    }

    return (
        <div className='on-boarding-box-container convention'>
            <div className='on-boarding-step convention links'>
                <div className='step-title'>
                    {generalStore.translate('welcome')}!
                </div>
                <div className='step-description'>
                    <span>
                        {generalStore.translate('youAreNowPartOfTheRotaxenginesWorkspaceIn')}&nbsp;
                        <b>frontline.io</b>.&nbsp;
                        {generalStore.translate('allThatIsLeftIsToDownloadTheApplicationAndLogInWithTheEmailAndPasswordYouUsedToSignUp')},
                    </span>

                </div>
                <div className='step-description'>
                    <div>
                        <b>{generalStore.translate('first')}</b>:
                    </div>
                    <div className='download-app-btns'>
                        <Button
                            onClick={Utility.downloadApp}
                            className='primary-button'
                            variant='outlined'
                        >
                            {generalStore.translate('downloadApp')}
                        </Button>
                    </div>
                </div>


                <div className='step-description'>
                    <div>
                        <b>{generalStore.translate('then')}&nbsp;
                            {generalStore.translate(projectIds.length > 1 ? 'selectModelToView' : 'viewModel', true)}</b>:
                    </div>
                    <div className='open-project-btns'>
                        {projectIds.map((projectId, i) => {
                            const project = Settings.conventionProjects[projectId];
                            const {name, procedureRef} = project;
                            const procedureIdAnProject = projectId + '~' + procedureRef;
                            // TODO hack for allowing mirrored
                            const deepLink = getProcedureDeepLink(procedureIdAnProject);
                            return (
                                <Button
                                    className='delete-button'
                                    onClick={() => {
                                        console.log(deepLink)
                                        window.location.href = deepLink
                                    }}
                                    variant='outlined'
                                    key={projectId + i}
                                >
                                    {name}
                                </Button>
                            )
                        })}
                    </div>
                </div>
                <div className='step-description column'>
                    <div>
                        {generalStore.translate('forMoreInformationPleaseReferToOur')}&nbsp;
                        <div className='link' onClick={Utility.openHelpdesk}>
                            {generalStore.translate('helpCenter')}
                        </div>
                    </div>
                    <div>
                        <div className='all-caps'>
                            {generalStore.translate('or')}
                        </div>
                        {generalStore.translate('contactUsAt')}
                        <a href='mailto:support@frontline.io'>support@frontline.io</a>
                    </div>
                </div>
            </div>
        </div>
    )
});

export default ConventionLinks;
